export default [
    {
        text: 'Folio',
        value: 'number',
    },
    {
        text: 'fecha emisión',
        value: 'emission_date',
        format: 'date'
    },
    {
        text: 'tipo documento',
        value: 'documentType',
    },
    {
        text: 'Neto',
        value: 'net_total',
        format: 'currency',
    },
    {
        text: 'IVA',
        value: 'iva',
        format: 'currency',
    },
    {
        text: 'Total',
        value: 'total',
        format: 'currency',
    },
    {
        text: 'fecha vencimiento',
        value: 'payDate',
        format: 'date'
    },
    {
        text: 'fecha pago',
        value: 'realPayDate',
        format: 'date'
    },
    {
        text: 'Estado',
        value: 'status',
    }
]
